import React from "react";
import { Box, Grid, Typography, Paper, Container } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import SchoolIcon from "@mui/icons-material/School";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import ComputerIcon from "@mui/icons-material/Computer";
import FactoryIcon from "@mui/icons-material/Factory";
import HomeWorkIcon from "@mui/icons-material/HomeWork";

const industries = [
  { name: "Real Estate", icon: <BusinessIcon /> },
  { name: "Fashion", icon: <CheckroomIcon /> },
  { name: "Education", icon: <SchoolIcon /> },
  { name: "Finance", icon: <AccountBalanceIcon /> },
  { name: "Health Care", icon: <LocalHospitalIcon /> },
  { name: "Information Technology", icon: <ComputerIcon /> },
  { name: "Manufacturing", icon: <FactoryIcon /> },
  { name: "Home Services & Others", icon: <HomeWorkIcon /> },
];

const Industries = () => {
  return (
    <Box sx={{ textAlign: "center", py: 5, background: "transparent", color: "white" }}>
      <Container>
        <Typography sx={{ color: "white", marginBottom: "25px" }} variant="h5" fontWeight={600} gutterBottom>
          Industries, we are serving
        </Typography>
        <Grid container spacing={2} justifyContent="center">
          {industries.map((industry, index) => (
            <Grid item xs={12} sm={6} md={6} key={index}>
              <Paper
                elevation={3}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  padding: 2,
                  borderRadius: 2,
                  backgroundColor: "transparent",
                  color: "#B6BFE080",
                  cursor: "pointer",
                  borderColor: "#B6BFE080",
                  border: "3px solid",
                  '&:hover': { backgroundColor: "#C64BCE" }
                }}
              >
                {industry.icon}
                <Typography style={{ color: "white" }}>{industry.name}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
        <Box sx={{ mt: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <img src="/img/about/about-1.gif" alt="GIF" style={{  objectFit: 'cover' }} />
          </Box>
          <Typography variant="h6" fontWeight={600} mt={1} sx={{ color: "#fff", mb: 2 }}>
            Directing Our Ship
          </Typography>
          <Typography variant="body1" sx={{ maxWidth: "600px", margin: "auto", color: "white" }}>
            The road to success is an ongoing process of change rather than a final destination.
            You get closer to greatness with every step, even if you start at the bottom.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Industries;